import { users as API } from '../../api'
import { equals } from 'w3box-utils'

// initial state
const state = {
  user: null,
  settings: {
    theme: 'dark',
    depts: [],
    users: [],
  },
  routes: {
    main: {
    },
    user: {
      logout: 'Logout',
    },
  }
}

// getters
const getters = {
  authenticated: state => !!state.user,
  user: state => state.user,
  settings: state => state.settings,
  dark: stat => state.settings.theme == 'dark',
  routes: state => state.routes,
  hasRoute: state => route => !!(state.routes.main && state.routes.main[route.path] || state.routes.user[route.path]),
  canEdit: state => type => getters.hasRoute(state)({path: '/'+type}),
}

// actions
const actions = {
  setStatus({ commit }, data) {
    commit('STATUS', data)
  },
  login({ commit, dispatch }, credentials) {
    const promise = API.login(credentials)
    promise
      .then(response => commit('LOGIN'))
      .catch(failed => dispatch('failed', failed, { root: true }))
    return promise
  },
  logout({ commit, dispatch }) {
    const promise = API.logout()
    promise
      .then(response => commit('LOGOUT'))
      .catch(failed => dispatch('failed', failed, { root: true }))
    return promise
  },
  updateProfile({ state, commit, dispatch }, data) {
    const promise = API.updateProfile(data)
    promise
      .then(response => commit('PROFILE', response))
      .catch(failed => dispatch('failed', failed, { root: true }))
    return promise
  },
  unauthorize({ commit }) {
    document.location = '/'
  },
  setSettings({ commit, dispatch, state }, settings) {
    const promise = API.setSettings({
      ...state.settings,
      ...settings
    })
    promise
      .then(response => commit('SETTINGS', response))
      .catch(failed => dispatch('failed', failed, { root: true }))
    return promise
  },
  switchTheme({ commit, dispatch, state }) {
    const promise = API.setSettings({
      ...state.settings,
      theme: state.settings.theme == 'dark' ? 'light' : 'dark'
    })
    promise
      .then(response => commit('SETTINGS', response))
      .catch(failed => dispatch('failed', failed, { root: true }))
    return promise
  },
}

// mutations
const mutations = {
  LOGIN: (state) => {
    document.location = '/'
  },
  LOGOUT: (state) => {
    state.user = null
    document.location = '/'
  },
  STATUS: (state, response) => {
    state.user = response.user
    state.settings = {
      ...state.settings,
      ...response.settings
    }
    state.routes = response.routes
  },
  PROFILE: (state, data) => {
    state.user = {
      ...state.user,
      ...data,
    }
  },
  SETTINGS: (state, settings) => {
    state.settings = settings
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}